import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import filter from 'lodash/filter'
import MdInfo from 'react-icons/lib/md/info'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdCheck from 'react-icons/lib/md/check'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdRemoveCircle from 'react-icons/lib/md/remove-circle'
import MdAccessTime from 'react-icons/lib/md/access-time'
import TagsFilter from '../../../../components/fields/TagsFilter'
import MdAssignmentTurnedIn from 'react-icons/lib/md/assignment-turned-in'
import MdAssignment from 'react-icons/lib/md/assignment'
import withOrganization from 'App/Decorators/withOrganization'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import autobind from 'autobind-decorator'

@withOrganization
@withRouter
@withMessage
export default class Archived extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    userId: PropTypes.string
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/admin/${this.props.userId}/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: '',
          name: 'documentStatus{status}',
          render: ({documentStatus}) => this.renderIcon(documentStatus)
        },
        {title: 'Nombre', name: 'name'}
      ]
    }
    return [
      {
        title: '',
        name: 'documentStatus{status}',
        render: ({documentStatus}) => this.renderIcon(documentStatus)
      },
      {title: 'Nombre', name: 'name'},
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}',
        render: ({signersStatus, documentStatus}) =>
          this.renderSignerStatus(signersStatus, documentStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      }
    ]
  }

  renderIcon(documentStatus) {
    if (documentStatus.status === 'ready') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'sent') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAccessTime className={styles.icon2} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'personal') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignment className={styles.icon3} size={20} />}
          </Tooltip>
        </div>
      )
    }
  }

  renderTooltipDocument(documentStatus) {
    //console.log("====> renderTooltipDocument " + documentStatus);
    if (documentStatus.status === 'ready') {
      return <p>Documento firmado</p>
    } else if (documentStatus.status === 'feaFlow') {
      return <p>Esperando firmas electrónicas avanzadas</p>
    } else if (documentStatus.status === 'bioFlow') {
      return <p>Esperando autorizaciones biométricas</p>
    } else if (documentStatus.status === 'sent') {
      return <p>Esperando firmas del documento</p>
    } else if (documentStatus.status === 'personal') {
      return <p>Documento personal</p>
    } else {
      return <p>Documento no enviado para firmar</p>
    }
  }

  renderSignerStatus(signersStatus, documentStatus) {
    const pendingSigns = filter(signersStatus, signerStatus => signerStatus.didSign).length
    if (documentStatus.status === 'personal') {
      return (
        <div>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <MdCheckCircle size={17} style={{color: '#3CB371'}} />
            </div>
            <div className="col-xs-12 col-sm-8">Propio</div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Tooltip content={this.renderTooltipContent(signersStatus)}>
              {this.renderTooltip(pendingSigns, signersStatus)}
            </Tooltip>
          </div>
          <div className="col-xs-12 col-sm-8">
            <span>
              {pendingSigns} de {signersStatus.length}
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderTooltip(pendingSigns, signersStatus) {
    if (signersStatus.length === 0) {
      return <MdRemoveCircle size={17} style={{color: '#e4ac00'}} />
    }
    if (pendingSigns === signersStatus.length) {
      return <MdCheckCircle size={17} style={{color: '#3CB371'}} />
    }
    return <MdInfo size={17} />
  }

  renderTooltipContent(signersStatus) {
    if (signersStatus.length === 0) {
      return <p> Documento sin firmantes</p>
    }
    return signersStatus.map((signerStatus, key) => {
      return (
        <p key={key}>
          {signerStatus.didSign && <MdCheck style={{color: 'green', marginRight: 5}} />}
          {signerStatus.email}
        </p>
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Todos los documentos archivados</h3>
          </div>
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              headRightComponent={TagsFilter}
              defaultLimit={25}
              queryName="userArchived"
              fields={this.getFields()}
              params="$filter: String $tags: [String] $userId: String"
              userId={this.props.userId}
              ref="paginated"
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/UserInformation/Archived/index.js